import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const CircleImageStyled = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: ${(props) =>
        props.isPrimary
            ? props.windowWidth > 768
                ? '228px'
                : '174px'
            : props.windowWidth > 768
            ? '373px'
            : '274px'};
    box-sizing: border-box;

    .image {
        padding: ${(props) => (props.isPrimary ? '8px' : '0')};
        background-color: ${(props) =>
            props.isPrimary ? props.theme.colors.backgrounds.white : 'none'};
        border: ${(props) =>
            props.isPrimary ? props.theme.borders.circleImage : 'none'};
        border-radius: 50%;
        box-sizing: border-box;
    }

    p {
        margin-top: 18px;
        font: 1.4375rem ${(props) => props.theme.fonts[0]}, sans-serif;
        letter-spacing: 0.03px;
        line-height: 2rem;
        text-align: center;

        @media screen and (max-width: 768px) and (min-width: 375px) {
            font-size: 1.2rem;
            line-height: 1.2rem;
        }
    }

    .dot-grid {
        position: absolute;
        left: 0;
        bottom: -10px;

        @media screen and (min-width: 768px) {
            bottom: -13px;
        }
    }
`;

export default function CircleImage({
    className,
    imgAlt,
    imgSrc,
    imgTitle,
    isPrimary,
    title,
    windowSize,
}) {
    return (
        <CircleImageStyled
            className={className}
            isPrimary={isPrimary}
            windowWidth={windowSize.width}
        >
            <img
                className="image"
                src={imgSrc}
                width={
                    isPrimary
                        ? windowSize.width > 1024
                            ? '228'
                            : windowSize.width > 375
                            ? '150'
                            : '174'
                        : windowSize.width > 1024
                        ? '373'
                        : '274'
                }
                height={
                    isPrimary
                        ? windowSize.width > 1024
                            ? '228'
                            : windowSize.width > 375
                            ? '150'
                            : '174'
                        : windowSize.width > 1024
                        ? '373'
                        : '274'
                }
                alt={imgAlt}
                title={imgTitle}
            />
            {!isPrimary ? (
                <img
                    className="dot-grid"
                    src={require('../../images/dot-grid.png')}
                    width={windowSize.width > 768 ? '114' : '85'}
                    alt={imgAlt}
                    title={imgTitle}
                />
            ) : null}
            {title ? <p>{title}</p> : null}
        </CircleImageStyled>
    );
}

CircleImage.propTypes = {
    className: PropTypes.string,
    imgAlt: PropTypes.string.isRequired,
    imgSrc: PropTypes.string.isRequired,
    imgTitle: PropTypes.string.isRequired,
    isPrimary: PropTypes.bool,
    title: PropTypes.string,
    windowSize: PropTypes.object.isRequired,
};

CircleImage.defaultProps = {
    isPrimary: true,
};
